import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { LANGUAGES, translations } from "@/lib/i18n";

const LanguageContext = createContext({
  lang: "en",
  setLang: () => {},
  t: translations.en,
});

const STORAGE_KEY = "baltivex_lang";

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState("en");

  useEffect(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
    if (stored && translations[stored]) {
      setLangState(stored);
      document.documentElement.lang = stored;
    } else {
      const nav = (typeof navigator !== "undefined" && navigator.language) || "en";
      const code = nav.slice(0, 2).toLowerCase();
      if (translations[code]) {
        setLangState(code);
        document.documentElement.lang = code;
      }
    }
  }, []);

  const setLang = (code) => {
    if (!translations[code]) return;
    setLangState(code);
    localStorage.setItem(STORAGE_KEY, code);
    document.documentElement.lang = code;
  };

  const value = useMemo(
    () => ({ lang, setLang, t: translations[lang] || translations.en, languages: LANGUAGES }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
